import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/Home.vue'
import Download from '../views/Download.vue'
import Secure from '@/views/Secure.vue'
import Video from '@/views/Video.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/download/:id?',
    name: 'download',
    component: Download
  },
  {
    path: '/secure',
    name: 'secure',
    component: Secure
  },
  {
    path: '/tutorial',
    name: 'tutorial',
    component: Video
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

export default router
